import { OnInit, OnDestroy, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogContentBase, DialogRef } from "@progress/kendo-angular-dialog";
import { MDMService } from "app/reusable/mdm.service";
import { UserProfile } from "app/_models";
import { AuthenticationService } from "app/_services";
import { CedNotificationService } from "ced-ng-library";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccountModel } from "../Models/AccountModel";

@Component({
    selector: 'app-user-account-details',
    templateUrl: './user-account-details.component.html',
    styleUrls: ['./user-account-details.component.scss']
  })

export class UserAccountDetailsComponent extends DialogContentBase  implements OnInit, OnDestroy {

    public userAccountForm = new FormGroup({});    
    yesNoValues: any[] = [
        { id: 1, name: "Yes" },
        { id: 0, name: "No" },
      ];

    langValues: any[] = [
        { id: 1, name: "Dutch" },
        { id: 2, name: "ENglish" },
      ];
    errorPopup :any = null;
    private _subject$: Subject<boolean> = new Subject();
    private selectedItem : AccountModel = null;
    private profile: UserProfile = new UserProfile()
    roles : string  [] = [];

    constructor(
        dialog: DialogRef,
        private mdmService: MDMService,
        private cedNotificationService: CedNotificationService,
        private authenticationService: AuthenticationService,        
        ) { 
        super(dialog);
        this.setProfile();        
    }
      
    ngOnInit(): void {
        
        this.initForm();
        this.populateControls();
    }

    setProfile() {
        let _currentUser = this.authenticationService.currentUserValue;
        this.profile.fullName = _currentUser.name;
        this.profile.emailAddress = _currentUser.unique_name;
        this.profile.familyName = _currentUser.family_name;
        this.profile.givenName = _currentUser.given_name;
        this.profile.ipAddress = _currentUser.ipaddr;
      }

    initForm(){
        this.userAccountForm = new FormGroup({
            empFirstName: new FormControl(null, Validators.required),
            empLastName: new FormControl(null, Validators.required),
            userName: new FormControl(null, ),
            empInactive: new FormControl(null, Validators.required),
            lastLoggedIn: new FormControl(null),
            role: new FormControl(null,Validators.required),
            language: new FormControl(null),
            empEmail:new FormControl(null, [Validators.email, Validators.required])
        });
    }

    getGroupRoles(){
        this.mdmService
        .getGroupRoles()
        .pipe(takeUntil(this._subject$))
        .subscribe((data : any) => {
            data.forEach(d => {
                this.roles.push(d.id);
            });              
            if(this.selectedItem != null){
                let userRoles = [];
                this.selectedItem.authorizationRoles.forEach(role => {
                    userRoles.push(role)
                });
                this.userAccountForm.controls.role.setValue(userRoles);
            }
        });
    }
    populateControls(){
        if(this.selectedItem != null){
            this.userAccountForm.controls.empFirstName.setValue(this.selectedItem.firstName);
            this.userAccountForm.controls.empLastName.setValue(this.selectedItem.lastName);
            this.userAccountForm.controls.empEmail.setValue(this.selectedItem.email);
            
            let isActive = this.yesNoValues.find(x=>x.id == Number(!this.selectedItem.inactive));
            if(isActive != undefined)
                this.userAccountForm.controls.empInactive.setValue(isActive);
        }

        this.getGroupRoles();                                          
    }

    public onSaveAction() {
        let account = new AccountModel ();                
        account.firstName = this.userAccountForm.controls.empFirstName.value;
        account.lastName = this.userAccountForm.controls.empLastName.value;
        account.inactive = ! this.userAccountForm.controls.empInactive.value.id;
        account.email = this.userAccountForm.controls.empEmail.value.toLowerCase();
        this.userAccountForm.controls.role.value.forEach(role => {
            account.authorizationRoles.push(role);
        });
        account.id =this.selectedItem == null ? null : this.selectedItem.id ;

        if(this.userAccountForm.valid){
            if(this.selectedItem == null){  
                account.createdBy = this.profile.emailAddress;          
                account.lastModifiedBy = this.profile.emailAddress;            
                this.addNewAccount(account);
            }
            else{        
                account.lastModifiedBy = this.profile.emailAddress;          
                this.updateAccount(account);
            }
        } 
        else
        this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
    }          

    addNewAccount(account){
        this.mdmService
                .saveAccount(account)
                .pipe(takeUntil(this._subject$))
                .subscribe(
                    () => {
                        this.dialog.close(true);
                    });
    }

    updateAccount(account){
        this.mdmService
                .updateAccount(account)
                .pipe(takeUntil(this._subject$))
                .subscribe(
                    () => {
                        this.dialog.close(true);
                    });
    }

    changeActiveStatus(event){
        if(this.selectedItem != null && event == this.yesNoValues[1]){
                this.mdmService.getOpenReservedActionsByUserId(this.selectedItem.id)
                .pipe(takeUntil(this._subject$))
                .subscribe((data : any) => {
                    if(data.length > 0){
                        this.cedNotificationService.warning("NOTIFICATIONS.CANT_MAKE_THIS_USER_INACTIVE_BECAUSE_OF_OPEN_OR_RESERVED_ACTIONS_ASSOCIATED_TO_THIS_ACCOUNT");
                        this.userAccountForm.controls['empInactive'].setValue(this.yesNoValues[0]);
                    }
                });   
        }  
    }

    public onCancelAction() {
        this.dialog.close(null);
    }   

    ngOnDestroy(): void {
        this._subject$.unsubscribe();
    }
}